module.exports = __webpack_public_path__ + "img/lottery_ru_bg.7e94b9ea.png";